module.exports = __webpack_public_path__ + "img/oppo_a5_2020_green.b2b28b33.png";